import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

import { StyledAiHr } from "app/pages/sales-intelligence/modules/ai-agent/components/markdown-components";

import { StyledListItemDescriptionLoader, StyledLoaderWithGap, StyledTitleLoader } from "./styles";

const MessageLoaderLarge = () => {
    return (
        <Stack>
            <StyledTitleLoader />

            <StyledAiHr />

            <StyledListItemDescriptionLoader data-automation="message-loader">
                <PixelPlaceholderLoader
                    width={110}
                    height={14}
                />

                <PixelPlaceholderLoader
                    width={295}
                    height={40}
                />
                <PixelPlaceholderLoader
                    width={295}
                    height={40}
                />
                <PixelPlaceholderLoader
                    width={295}
                    height={40}
                />
            </StyledListItemDescriptionLoader>

            <StyledLoaderWithGap
                marginTop="16px"
                width={295}
                height={40}
            />
        </Stack>
    );
};

export default MessageLoaderLarge;
